import closeIcon from '@packages/shared/assets/cross.svg';
import Image from '@packages/shared/core/common/components/common/Image';
import Button from '@packages/shared/core/common/components/common/Button';
import Modal from '@packages/shared/core/common/components/common/Modal';
import { DataTestId } from '@packages/shared/core/common/constants/dataTestId';
import styles from './ExpertsCatalogueScreenModal.module.scss';

type ExpertsCatalogueScreenModalProps = {
  open: boolean;
  onClose: () => void;
  icon: string;
  title: string;
  description: string;
  button: string;
};

export const ExpertsCatalogueScreenModal = ({
  open,
  onClose,
  description,
  icon,
  title,
  button,
}: ExpertsCatalogueScreenModalProps) => {
  return (
    <Modal disableBackdropClick open={open} onClose={onClose} data-testid={DataTestId.FREE_READING_MODAL}>
      <div className={styles.wrapper}>
        <Image
          className={styles.close}
          type="future"
          src={closeIcon}
          alt="close"
          width={16}
          height={16}
          onClick={onClose}
        />

        <Image src={icon} alt="clock" width={62} height={62} layout="fixed" />

        <h3 className={styles.title}>{title}</h3>

        <p className={styles.description}>{description}</p>

        <Button
          wrapperClassName={styles.buttonWrapper}
          onClick={onClose}
          className={styles.button}
          data-testid={DataTestId.FREE_READING_MODAL_SUBMIT_BUTTON}
        >
          {button}
        </Button>
      </div>
    </Modal>
  );
};

export default ExpertsCatalogueScreenModal;
